export default "27.2.031\n"